"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Meta = void 0;
/**
 * [
  'meta_1',     'created',
  'active',     'name',
  'pri',        'altered',
  'old_meta_2', 'meta_2',
  'sql_id',     'old_meta_1',
  'group',      'old_group',
  'hidden'
]
 */
class Meta {
    constructor(meta) {
        this.active = meta.active;
        this.altered = meta.altered;
        this.created = meta.created;
        this.description = meta.description;
        this.type = meta.type;
        this.name = meta.name;
        this.sql_id = meta.sql_id;
        this.querySnap = meta.querySnap;
        this.documentId = meta.documentId;
        this.ref = meta.ref;
    }
    async fromCollection(collection) {
        const collectionSnapshot = await collection.get();
        return this.fromDocumentSnapshotArray(collectionSnapshot.docs);
    }
    fromDocumentSnapshot(documentSnapshot) {
        return new Meta({
            ...documentSnapshot.data(),
            querySnap: documentSnapshot,
            documentId: documentSnapshot.id,
            ref: documentSnapshot.ref
        });
    }
    fromDocumentSnapshotArray(documentSnapshot) {
        return documentSnapshot.map(document => {
            return new Meta({
                ...document.data(),
                querySnap: document,
                documentId: document.id,
                ref: document.ref
            });
        });
    }
}
exports.Meta = Meta;
//# sourceMappingURL=Meta.js.map